var map = {
	"./activities/_index.js": "RVxt",
	"./dashboard/_index.js": "0MYX",
	"./distribution/_index.js": "RQ+5",
	"./export-db/_index.js": "IhR+",
	"./master/_index.js": "p6Xz",
	"./stock-management/_index.js": "9aZH",
	"./user-role/_index.js": "/wLf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGqA";


//////////////////
// WEBPACK FOOTER
// ./src/modules _index\.js$
// module id = wGqA
// module chunks = 300